import {Service} from "@/apiServices/Service";

export class FacturacionService extends Service{

    constructor() {
        super('facturacion/');
    }

    generarNotaCredito(idRecibo, idFactura) {
        return this.http.post(this.getUrl(['generar', 'notaCredito'], {idRecibo, idFactura }))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .then((r) => {
                this.swalSuccess('Se ha generado correctamente la Nota de Crédito')
                return r;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}
